import { faSpinnerThird as fasSpinnerThird } from '@fortawesome/pro-duotone-svg-icons';

import { Icon, IconProps, cn } from '@growtherapy/sprout-ui';

type LoadingSpinnerProps =
  | (Omit<IconProps, 'name' | 'variant' | 'className'> & {
      className?: string;
      'aria-label': string;
      'aria-hidden': false;
    })
  | {
      className?: string;
      'aria-label'?: never;
      'aria-hidden'?: true;
    };

export function LoadingSpinner(passThroughProps: LoadingSpinnerProps) {
  const { className, ...props } = passThroughProps;
  return <Icon className={cn('text-neutral-900 fa-spin', className)} icon={fasSpinnerThird} {...props} />;
}
